(() => {
  'use strict';

  const shopify = window.Shopify;
  const current = new URL(window.location.href);
  const indiaHosts = ['shop.aitutorsanta.in', 'aitutorsanta.in', 'fyfb1i-3y.myshopify.com'];
  const sessionKey = 'santa-india-global-redirect-v1';

  // Published India storefront only. Preview links, editor frames, and checkout stay usable.
  if (!indiaHosts.includes(current.hostname) || shopify?.shop !== 'fyfb1i-3y.myshopify.com' ||
      shopify?.theme?.role !== 'main' || shopify.designMode || shopify.visualPreviewMode ||
      window.self !== window.top || current.searchParams.has('preview_theme_id') ||
      current.searchParams.has('preview_key') || current.searchParams.has('_fd') ||
      /bot|crawler|spider|slurp|facebookexternalhit|headlesschrome|lighthouse/i.test(navigator.userAgent) ||
      /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|carts|checkout|checkouts|account|accounts|orders|apps|challenge|password|customer_authentication)(?:\/|$)/i.test(current.pathname) ||
      window.SantaIndiaCountryRedirectStarted) return;

  // If storage is unavailable, preserve browsing rather than risking a redirect loop.
  try {
    if (window.sessionStorage.getItem(sessionKey)) return;
    window.sessionStorage.setItem(`${sessionKey}-check`, '1');
    window.sessionStorage.removeItem(`${sessionKey}-check`);
  } catch { return; }
  window.SantaIndiaCountryRedirectStarted = true;

  let interacted = false;
  let timedOut = false;
  const onInteraction = () => { interacted = true; };
  window.addEventListener('pointerdown', onInteraction, { once: true, passive: true });
  window.addEventListener('keydown', onInteraction, { once: true });
  const controller = new AbortController();
  const timeout = window.setTimeout(() => { timedOut = true; controller.abort(); }, 2000);

  (async () => {
    try {
      // Use detected IP country, never localization.country or the selected/backup market.
      // This first-party endpoint is also used by the existing global purchase policy.
      const root = new URL(shopify.routes?.root || '/', current.origin);
      if (root.origin !== current.origin) return;
      const endpoint = new URL('browsing_context_suggestions.json', root);
      endpoint.searchParams.set('country[enabled]', 'true');
      const response = await fetch(endpoint.href, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) return;
      const country = (await response.json())?.detected_values?.country?.handle;
      if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country) || ['IN', 'KR', 'XX', 'ZZ'].includes(country)) return;
      if (timedOut || interacted || window.location.href !== current.href) return;

      // Product handles, carts, and login tokens belong to different stores: use the global home.
      const destination = new URL('https://shop.aitutorsanta.com/');
      for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid']) {
        const value = current.searchParams.get(key);
        if (value) destination.searchParams.set(key, value);
      }
      window.sessionStorage.setItem(sessionKey, '1');
      window.location.replace(destination.href);
    } catch {
      // Network, response, or storage failures must never block the India storefront.
    } finally {
      window.clearTimeout(timeout);
      window.removeEventListener('pointerdown', onInteraction);
      window.removeEventListener('keydown', onInteraction);
    }
  })();
})();
